module.exports = __webpack_public_path__ + "media/images/memes/high-five-c833e94c0fcc6ca74daf2a138d4e3304.gif";